/* eslint-disable no-dupe-keys */
export default {
  service_provider_withdraw_application: {
    name: '运营商提现申请',
    // 属性（一般与对象内容匹配）
    prop: {
      process_number: '工单号',
      applied_amount: '申请金额',
      balance: '余额',
      after_balance: '提现后余额',
      before_balance: '提现前余额',
      admin: '申请人',
      service_provider: '运营商',
      withdrawal_type: '提现类型',
      withdrawal_model: '提现方式',
      bank_account_name: '银行卡户名',
      sp_transaction_record_id: '结算流水',
      amount: '流水分摊金额',
      before_withdrawable_amount: '提现前剩余可提现的金额',
      after_withdrawable_amount: '提现后剩余可提现的金额',
      bank_account_number: '银行卡账号',
      bank_name: '开户行',
      status: '状态',
      note: '备注',
      unified_note: '统一备注',
      latest_transition: '最后审核人员/信息',
      applied_total_amount: '总金额',
      created_at: '创建时间',
      updated_at: '更新时间',
      bank_account: '收款账户',
      account_info: '账户信息',
      accounting_date: '账单时间',
      charge_station: '充电站',
      is_merged_stations_application: '按充电站拆单',
      accounting_date: '账单时间'
    },
    // Enum的属性
    statuses: {
      pending: '待审核',
      passed: '待转账',
      transferred: '已转账',
      rejected: '已拒绝'
    },
    is_merged_stations_application: {
      true: '按运营商申请',
      false: '按充电站申请'
    },
    // 提现类型
    withdrawal_models: {
      self_withdrawal: '自提现',
      proxy_withdrawal: '代提现',
      auto_withdrawal: '自动提现'
    },
    list_tabs: {
      all: '全部'
    },
    labels: {
      total_count: '数量',
      total_amount: '金额'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_admin: '请选择提款人',
      input_password: '请输入登录密码',
      input_description: '备注说明'
    },
    validates: {
      input_can_withdraw_amount: '请输入可提现余额范围内数值',
      input_nonzero: '请输入非零数值'
    },
    group_titles: {
      base: '申请信息',
      bank_info: '银行信息',
      transaction_record: '扣除的结算流水记录',
      previous_withdraw_record: '过往的提现记录（近十条）'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    tips: {
      no_bank_account: '没有设置提款账号'
    },
    input: {
      authentication: '身份验证'
    },
    btns: {
      create: '提交申请'
    },
    withdrawal_types: {
      wallet_balance: '钱包余额',
      prepayment: '预付款'
    }
  }
}
